var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.25 6-1.06-1.06a1.5 1.5 0 0 0-1.061-.44H2.25a.75.75 0 0 0-.75.75v14c0 .138.112.25.25.25h20.5a.25.25 0 0 0 .25-.25V6.75a.75.75 0 0 0-.75-.75h-10.5z",
    fill: "#FFB900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m11.25 6-1.06 1.06a1.5 1.5 0 0 1-1.061.44H1.5v11.75c0 .138.112.25.25.25h20.5a.25.25 0 0 0 .25-.25V6.75a.75.75 0 0 0-.75-.75h-10.5z",
    fill: "#FFD75E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m11.25 6-1.06 1.06a1.5 1.5 0 0 1-1.061.44H1.5v11.75c0 .138.112.25.25.25h20.5a.25.25 0 0 0 .25-.25V6.75a.75.75 0 0 0-.75-.75h-10.5z",
    fill: "url(#944ohfbota)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M1.5 7.5v.25h7.65c.464 0 .91-.184 1.238-.513L11.625 6h-.375l-1.06 1.06a1.5 1.5 0 0 1-1.061.44H1.5z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 19.5H1.75a.25.25 0 0 1-.25-.25h21a.25.25 0 0 1-.25.25z",
    fill: "#DA7B16"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "944ohfbota",
    x1: 12,
    y1: 6,
    x2: 12,
    y2: 19.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD75E",
    stopOpacity: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/Folder.01a7b82dfb36d5356460abd9d1e0a22e.svg";
export { ForwardRef as ReactComponent };